<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات تنوع محصول"
        >
          <b-form
            ref="productvarietyform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                      <b-row v-show="false">
                        <b-col md="12">
                          <b-form-group
                            label="عنوان"
                            label-for="Title"
                            class="mb-0"
                          >
                            <b-form-input
                              id="Title"
                              v-model="Form.Title"
                              name="Title"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col
                    v-for="(item, index) in ProductAttribute"
                    md="4"
                  >
                    <b-form-group
                      :label="item.Title"
                      :label-for="'ProductAttribute'+ index"
                    >
                      <b-form-input
                        v-model="item.Description"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="وضعیت"
                      label-for="Status"
                    >
                      <v-select
                        v-model="Form.Status"
                        :options="enums('ProductStatus')"
                        dir="rtl"
                        label="text"
                        name="Status"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="بارکد"
                      label-for="Barcode"
                    >
                      <b-form-input
                        v-model="Form.Barcode"
                        autocomplete="off"
                        name="Barcode"
                        :disabled="Form.HasVariety"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="قیمت"
                      label-for="Price"
                    >
                      <b-input-group append="تومان">
                        <cleave
                          v-model="Form.Price"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="تخفیف"
                      label-for="Discount"
                    >
                      <b-input-group append="تومان">
                        <cleave
                          v-model="Form.Discount"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="تعداد"
                      label-for="Quantity"
                    >
                      <b-form-input
                        v-model="Form.Quantity"
                        autocomplete="off"
                        type="number"
                        name="Quantity"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="حداقل تعداد سفارش"
                      label-for="MinOrderQuantity"
                    >
                      <b-form-input
                        v-model="Form.MinOrderQuantity"
                        autocomplete="off"
                        type="number"
                        name="MinOrderQuantity"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="حداکثر تعداد سفارش"
                      label-for="MaxOrderQuantity"
                    >
                      <b-form-input
                        v-model="Form.MaxOrderQuantity"
                        autocomplete="off"
                        type="number"
                        name="MaxOrderQuantity"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-input
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          autocomplete="off"
                        />
                      </div>
                    </b-form-group>

                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

export default {
  name: 'ProductVarietyDetails',
  components: {},
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
      },
      loading: false,
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      ProductAttribute: [],

    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
    }

    this.Form.ProductId = this.$route.query.productid

    this.getAllProductAttribute()
  },
  methods: {
    save() {
      let url = this.$api.productvariety.add
      if (this.$route.params.id && this.$route.path.toLowerCase().includes('duplicate') === false) {
        url = this.$api.productvariety.update
      }

      console.log(this.ProductAttribute)
      // return

      const formData = new FormData(this.$refs.productvarietyform)
      formData.append('Id', this.Form.Id)
      formData.append('ProductId', this.Form.ProductId)
      formData.append('Description', this.Form.Description)

      this.ProductAttribute.forEach((item, index) => {
        formData.append(`ProductVarietyAttribute[${index}].ProductAttributeId`, item.Id)
        if (item.Description) {
          formData.append(`ProductVarietyAttribute[${index}].Title`, item.Description)
        }
      })

      formData.append('Status', this.Form.Status)

      if (this.Form.Price) {
        formData.append('Price', this.Form.Price.replaceAll(',', ''))
      }

      if (this.Form.Discount) {
        formData.append('Discount', this.Form.Discount.replaceAll(',', ''))
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.productvariety.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data

          this.ProductAttribute.forEach(item => {
            const pa = this.Form.ProductVarietyAttribute.filter(x => x.ProductAttributeId == item.Id)
            if (pa) {
              item.Description = pa[0].Title
            }
          })
        })
    },
    getAllProductAttribute() {
      this.loading = true
      this.$http.post(
        '/productattribute/getall', {
          ProductId: this.Form.ProductId,
        },
      )
        .then(res => {
          this.loading = false
          this.ProductAttribute = res.data

          if (this.$route.params.id) {
            this.get()
          }
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
